const selectFirstOnEnter = (input) => {
    // store original event listener
    const initialEventListener = input.addEventListener;

    const addEventListenerWrapper = (type, listener) => {
        let eListener = listener;

        if (type === 'keydown') {
            // store existing listener function
            const initialListener = listener;

            eListener = (event) => {
                // simulate a 'down arrow' keypress if no address has been selected
                const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;
                if (event.key === 'Enter' && !suggestionSelected) {
                    const e = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        code: 'ArrowDown',
                        keyCode: 40,
                    });
                    initialListener.apply(input, [e]);
                }
                initialListener.apply(input, [event]);
            };
        }
        initialEventListener.apply(input, [type, eListener]);
    };

    input.addEventListener = addEventListenerWrapper;
};

export default selectFirstOnEnter;
